
import LeftbarAdmin from "./LeftbarAdmin";

const Leftbar = ({ showSidebar,handleSidebarClose }) => {
  return (
    <>
        <LeftbarAdmin customClass="d-none d-md-block" />
      
      {showSidebar && (
        <div className="mobile-sidebar-slide d-block d-md-none">
          <LeftbarAdmin handleSidebarClose={handleSidebarClose} />
        </div>
      )}
    </>
  );
};

export default Leftbar;
